/**
 * Supabase Client for Web App
 *
 * This module provides a Supabase client configured for authentication.
 * Used for OAuth (Google, Apple) and session management.
 * Reads configuration from environment variables.
 */

import { createClient } from "@supabase/supabase-js";

// Use staging Supabase by default in development
// Production uses Fly.io secrets which override these
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || import.meta.env.PUBLIC_SUPABASE_URL || "https://jreaptmvbfftsgyfisvn.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.PUBLIC_SUPABASE_ANON_KEY || "sb_publishable_Jf-O3OgLpmlgFYntqWIYzA_a18PChSm";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn("[Supabase] Missing URL or key, using fallback production values");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
